module.exports = __webpack_public_path__ + "static/media/img2.e314c966.svg";